export const sortOptionsMap = {
  '-rating': 'User rating',
  '-weighted_rating': 'User rating/most reviews',
  distance: 'Distance',
  magic: 'Our favourites',
  price: 'Price (Low to high)',
  '-price': 'Price (High to low)',
}
